import { render, staticRenderFns } from "./product-specification.vue?vue&type=template&id=2b8f24c2"
import script from "./product-specification.vue?vue&type=script&lang=js"
export * from "./product-specification.vue?vue&type=script&lang=js"
import style0 from "./product-specification.vue?vue&type=style&index=0&id=2b8f24c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports